import { render, staticRenderFns } from "./RxSingleFileUpload.vue?vue&type=template&id=252a8782&scoped=true"
import script from "./RxSingleFileUpload.vue?vue&type=script&lang=js"
export * from "./RxSingleFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252a8782",
  null
  
)

export default component.exports